import { DocumentCard, DocumentCardImage, IDropdownOption, ImageFit } from "@fluentui/react";
import { Utils } from "../../../common/views/Utils";
import { SortDirection } from "../../../home/models/PageTypes";
import { ProductUtils } from "../../../products/ProductUtils";
import { OrderStatus, OrderRejectReason, OrderTracking, OrderModel, ShortOrderItemModel } from "../../models/OrderModel";

export class OrderUtils {
    public static getAmount(item: ShortOrderItemModel): number {
        //return order.price * order.qty * (100 + order.rate) / 100;
        return 0;
    }

    public static getTotal(item: ShortOrderItemModel): number {
        //const amount = this.getAmount(order);
        //return amount + order.domesticShipping + order.chargeWeight * order.shippingRate;
        return 0;
    }

    public static getStatusText(status: OrderStatus): string {
        switch (status) {
            case OrderStatus.all: return "All";
            case OrderStatus.pending: return "Pending";
            case OrderStatus.approved: return "Approved";
            case OrderStatus.canceled: return "Canceled";
            case OrderStatus.declined: return "Declined";
            case OrderStatus.completed: return "Completed";
        }

        return "";
    }

    public static getStatusOptions(): IDropdownOption[] {
        const list = [
            { key: OrderStatus.pending, text: "Request" },
            { key: OrderStatus.approved, text: "Quote" },
            { key: OrderStatus.canceled, text: "Canceled" },
            { key: OrderStatus.declined, text: "Declined" },
            { key: OrderStatus.completed, text: "Completed" }
        ];

        return list;
    }

    public static getReasonOptions() {
        const list = [
            { key: OrderRejectReason.none, text: "None" },
            { key: OrderRejectReason.changeMind, text: "Change Mind" },
            { key: OrderRejectReason.damaged, text: "Damaged" },
            { key: OrderRejectReason.outOfStock, text: "Out of Stock" },
            { key: OrderRejectReason.priceTooHigh, text: "Price Too High" },
            { key: OrderRejectReason.waitTooLong, text: "Wait Too Long" }
        ];

        return list;
    }

    public static getTrackingOptions() {
        const list = [
            { key: OrderTracking.none, text: "None" },
            { key: OrderTracking.placedOnline, text: "Placed" },
            { key: OrderTracking.inForeignStock, text: "At WH" },
            { key: OrderTracking.shippedToDestination, text: "Shipped" },
            { key: OrderTracking.arrivedDestination, text: "Arrived" },
            { key: OrderTracking.readyForDelivery, text: "Ready Delivery" },
            { key: OrderTracking.outForDelivery, text: "Out Delivery" },
            { key: OrderTracking.delivered, text: "Delivered" }
        ];

        return list;
    }

    public static getSortOptions() {
        const list = [
            { key: 0, name: "None", direction: SortDirection.descending, text: "" },
            { key: 1, name: "Date", direction: SortDirection.descending, text: "Date Desc" },
            { key: 2, name: "Status", direction: SortDirection.ascending, text: "Status" },
            { key: 3, name: "Reason", direction: SortDirection.ascending, text: "Reason" },
            { key: 4, name: "Tracking", direction: SortDirection.ascending, text: "Tracking Asc" },
            { key: 5, name: "Tracking", direction: SortDirection.descending, text: "Tracking Desc" },
            { key: 6, name: "customer", direction: SortDirection.descending, text: "Customer" },
            { key: 7, name: "orderId", direction: SortDirection.descending, text: "Order #" },
            { key: 8, name: "invoiceId", direction: SortDirection.descending, text: "Invoice #" },
            { key: 9, name: "price", direction: SortDirection.descending, text: "Price Asc" },
            { key: 10, name: "price", direction: SortDirection.descending, text: "Date Desc" },
            { key: 11, name: "productName", direction: SortDirection.descending, text: "Product Name" },
            { key: 12, name: "productId", direction: SortDirection.descending, text: "Product #" }
        ];

        return list;
    }

    public static image = (url: string, qty: number, size: number, total: number, includeTotal: boolean) => {
        return <DocumentCard className="picture-wrapper" style={{ width: "100%" }}>
            <DocumentCardImage
                imageFit={ImageFit.centerCover}
                className="product-picture product-card-image"
                height={size}
                imageSrc={url}
            />

            {qty !== 0 && <div className="right" style={{ position: "relative", marginTop: -20 }}>
                <span className="count">{qty}</span>
            </div>}

            {includeTotal && <div className="center pt-5">
                <span className="font-smaller">est. $ {total.toFixed(0)}</span>
            </div>}
        </DocumentCard>
    }

    //public static ProductInfo = (item: ShortOrderItemModel) => {
    //    let line2 = ProductUtils.getSubInfoForOrder(item);

    //    return <>
    //        <div>{item.brand}</div>
    //        <div className="pt-5 gray limit-lines one-line">{item.productName}</div>
    //        <div className="pt-5">{line2}</div>
    //    </>;
    //}

    public static ShowTracking = (item: ShortOrderItemModel): boolean => {
        return item.status !== OrderStatus.canceled && item.status !== OrderStatus.declined;
        //return order.status === OrderStatus.orderApproved || order.status === OrderStatus.completed;
    }
}